import { defineStore } from 'pinia';
import { ref } from 'vue';
import { AddressLookupService } from '@/services/store';
import { INameValue } from '@/interfaces/entities/name-value.interface';
import { ISuburbLookupResult } from '@/interfaces/entities/risk-suburb-lookup-option.interface';

enum RefDataTypes {
  COUNTRIES = 'Countries',
}

export const useAddressLookupStore = defineStore('AddressLookupStore', () => {
  const addressData = ref<Partial<Record<RefDataTypes, INameValue[]>>>({});
  const riskSuburbsData = ref<ISuburbLookupResult[]>([]);

  async function getCountryLookup(
    key: string,
    allCountries: boolean,
    includeIso: boolean = false
  ): Promise<INameValue[]> {
    if (addressData.value?.Countries?.length) return addressData.value.Countries;
    try {
      const res = await AddressLookupService.getCountryLookup(key, allCountries, includeIso);
      addressData.value.Countries = res || [];
    } catch (error) {
      console.warn('Unable to fetch countries: ', error);
    }
    return addressData.value.Countries || [];
  }

  async function getInsuranceRiskSuburbsLookup(key: string) {
    try {
      const res = await AddressLookupService.getInsuranceRiskSuburbs(key);
      riskSuburbsData.value = res || [];
    } catch (error) {
      console.warn('Unable to fetch suburbs list: ', error);
    }
  }

  function setInsuranceRiskSuburbsLookup(suburbLookUpResult: ISuburbLookupResult[]) {
    riskSuburbsData.value = suburbLookUpResult;
  }

  return {
    getCountryLookup,
    getInsuranceRiskSuburbsLookup,
    setInsuranceRiskSuburbsLookup,
    riskSuburbsData,
  };
});
